import { createContext, ReactNode, useState } from 'react';

type ThemeContextType = 'light' | 'dark';

type ThemeContextProps = {
  children: ReactNode;
}

export const ThemeContext = createContext<ThemeContextType>('light');

export function ThemeContextProvider(props: ThemeContextProps) {
  const [currentTheme, setCurrentTheme] = useState('light');

  function toggleTheme() {
    setCurrentTheme(currentTheme !== 'light' ? 'dark' : 'light');
  }

  return (
    <ThemeContext.Provider value={'light'}>
      {props.children}
    </ThemeContext.Provider>
  );
}